import React from 'react';
import UserResults from '../components/users/UserResults';
import UserSearch from '../components/users/UserSearch';
import Alert from '../components/layouts/Alert';

function Home() {

  return <div>

           <UserSearch />
           <UserResults />
         
      
      </div>;
}

export default Home;
